module.exports = __webpack_public_path__ + "static/img/frack01.670d09ee.png";